import { mapGetters } from 'vuex';
import loaderMixin from '@/mixins/loader';
import marketKeyStatsElement from './market-key-stats-element/market-key-stats-element.vue';

function getOrderMobile(arr) {
  const odd = [];
  const even = arr.reduce((prev, curr, idx) => {
    if (idx % 2) {
      odd.push(curr);
      return prev;
    }
    prev.push(curr);
    return prev;
  }, []);
  return even.concat(odd);
}

export default {
  mixins: [loaderMixin],
  props: {
    widget: Object,
  },
  components: {
    marketKeyStatsElement,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    obj() {
      return this.widget ? this.widget : {};
    },
    items() {
      if (!this.widget) {
        return [];
      }
      return this.isLayoutMobile
        ? getOrderMobile(this.widget.widgetKeyStats)
        : this.widget.widgetKeyStats;
    },
  },
  watch: {
    widget(val) {
      if (val) {
        this.loaderRemove();
      }
    },
  },
  methods: {},
  mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  },
};
